import { serialize } from 'object-to-formdata';
import decamelizeKeys from '../utils/decamelize-for-files';
import api from './index';
export default { create(data) { const path = '/api/internal/feedback'; return api({ method: 'post', url: path, headers: { 'Content-Type': 'multipart/form-data' }, data: serialize(decamelizeKeys({ Feedback: data })) }).then(res => res?.feedback); } };
